import http from "../common/http-common";
import authHeader from '../common/auth-header';


class DashBoardService {





    
    get(id) {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)
        return http.get('/dossiers/dashboard', config);
    }

   
}
export default new DashBoardService();